/*
 * 自动生成 — 演示左侧文档预览的真实表格数据(脱敏人名)。
 * 源：用户提供的「编辑后」xlsx；重生成见 git 历史的 gen_sheet 脚本。
 */
export const DEMO_SHEET = {
  title: '照片台账表 · 2026-06-01 ~ 2026-06-18',
  cols: ['照片', '拍摄人', '水印名称', '拍摄时间', '拍摄地点', '施工安全'],
  rows: [
    ['📷', '李工', '', '06-18 09:55', '成都市武侯区·天府大道中段', ''],
    ['📷', '李工', '施工安全', '06-11 17:13', '北京市·颐泉汇B座', '施工安全'],
    ['📷', '李工', '施工安全', '06-11 17:13', '北京市·颐泉汇B座', '施工安全'],
    ['📷', '李工', '施工安全', '06-11 17:13', '北京市·颐泉汇B座', '施工安全'],
    ['📷', '李工', '施工安全', '06-11 17:12', '北京市·颐泉汇B座', '施工安全'],
    ['📷', '李工', '施工安全', '06-11 17:12', '北京市·颐泉汇B座', '施工安全'],
    ['📷', '李工', '施工安全', '06-11 17:12', '北京市·颐泉汇B座', '施工安全'],
    [
      '📷',
      '李工',
      '施工安全',
      '06-11 16:21',
      '北京市·小桔充电汽车充电站(清河站南G7桥下停车场慢充站)',
      '施工安全'
    ],
    [
      '📷',
      '李工',
      '施工安全',
      '06-11 16:21',
      '北京市·小桔充电汽车充电站(清河站南G7桥下停车场慢充站)',
      '施工安全'
    ],
    [
      '📷',
      '李工',
      '施工安全',
      '06-11 16:20',
      '北京市·小桔充电汽车充电站(清河站南G7桥下停车场慢充站)',
      '施工安全'
    ],
    [
      '📷',
      '李工',
      '施工安全',
      '06-11 16:19',
      '北京市·国家电网汽车充电站(北京市海淀区上地三街东口公共充电站)',
      '施工安全'
    ],
    [
      '📷',
      '李工',
      '施工安全',
      '06-11 16:19',
      '北京市·国家电网汽车充电站(北京市海淀区上地三街东口公共充电站)',
      '施工安全'
    ],
    [
      '📷',
      '李工',
      '施工安全',
      '06-11 16:18',
      '北京市·国家电网汽车充电站(北京市海淀区上地三街东口公共充电站)',
      '施工安全'
    ],
    [
      '📷',
      '李工',
      '施工安全',
      '06-11 16:18',
      '北京市·国家电网汽车充电站(北京市海淀区上地三街东口公共充电站)',
      '施工安全'
    ],
    ['📷', '王工', '工程水印', '06-02 17:12', '北京市海淀区·颐泉汇B座', ''],
    ['📷', '王工', '工程水印', '06-02 17:01', '北京市海淀区·颐泉汇B座', '']
  ]
}
export default DEMO_SHEET
